// Centre data - Soutien Scolaire Papara
import {
  GraduationCap,
  Bus,
  Sunrise,
  Palmtree,
  Gamepad2,
  BookOpen,
  Music,
  Trees,
  Heart,
  ShieldCheck,
  Sparkles,
  Users,
} from "lucide-react";

export const CONTACT = {
  phone: "+689 88 71 79 10",
  phoneRaw: "+68988717910",
  email: "soutienscolaire.papara@gmail.com",
  facebook: "https://www.facebook.com/profile.php?id=61560300151615",
  facebookLabel: "Soutien Scolaire Papara",
  adresse: "Papara, Tahiti — Polynésie française",
};

export const BANK = {
  beneficiaire: "RAHUNE",
  banque: "Banque de Tahiti",
  bic: "CEPAPFTPXXX",
  iban: "FR76 1223 9000 2052 4372 0100 021",
  code_banque: "12239",
  code_guichet: "00020",
  numero_compte: "52437201000",
  cle_rib: "21",
  domiciliation: "Banque de Tahiti",
  reference: "Nom + Prénom de l'enfant",
};

export const DEPOT_GARANTIE = 15000;

export const CONDITIONS_INSCRIPTION = [
  "S'abonner à un forfait vous engage pour une période de 11 mois (d'août à juin).",
  "Lors de l'inscription, un dépôt de garantie de 15 000 XPF est requis pour réserver la place de l'enfant. Ce dépôt sera renouvelable pour l'inscription de l'année suivante. Si vous ne réinscrivez pas votre enfant, le dépôt vous sera restitué. En cas d'annulation de l'abonnement avant la fin des 11 mois d'engagement, le dépôt sera perdu.",
  "L'inscription implique une assiduité pour optimiser l'efficacité de l'enseignement. Les absences pour raisons personnelles ne sont pas remboursées. Les cours peuvent être rattrapés uniquement si le planning le permet.",
  "Les paiements des prestations régulières doivent être effectués au plus tard le 5 du mois concerné. Passé ce délai, une pénalité de 10 % sera appliquée.",
  "Le parent qui inscrit l'enfant est responsable du règlement des factures. Un accord avec le/la conjoint(e) (ou ex-conjoint(e)) doit être trouvé pour le remboursement des frais si ceux-ci sont partagés.",
  "Merci de respecter les horaires de fermeture du centre. En cas de retards répétés, une pénalité de 3 000 XPF sera ajoutée à votre facture.",
  "Documents à fournir lors de l'arrivée au centre : 1 photo d'identité de l'enfant + 1 copie de l'assurance scolaire.",
];

// Services overview
export const SERVICES = [
  {
    id: "soutien",
    icon: GraduationCap,
    title: "Soutien scolaire",
    short: "De la maternelle au collège — accompagnement quotidien après l'école",
    desc: "Nous récupérons votre enfant à la sortie des cours, l'aidons avec ses devoirs et révisions, et lui offrons un goûter dans un environnement sécurisé.",
    color: "ocean",
  },
  {
    id: "matin",
    icon: Sunrise,
    title: "Accueil du matin",
    short: "Dès 4h — petit-déjeuner et dépose à l'école",
    desc: "Pour les parents qui partent tôt au travail : nous accueillons votre enfant dès 4h du matin, lui offrons le petit-déjeuner et le déposons à son école. L'esprit tranquille toute la matinée.",
    color: "coral",
  },
  {
    id: "transport",
    icon: Bus,
    title: "Ramassage scolaire",
    short: "Service de transport au départ de 8 écoles",
    desc: "Sur Papara : Taharuu, Apatea, Apea, Tiamao et le collège. Sur Mataiea : Mairipehe, Nuutafaratea et le collège.",
    color: "lagoon",
  },
  {
    id: "stages",
    icon: Palmtree,
    title: "Stages de vacances",
    short: "Maintenir la dynamique pendant les vacances",
    desc: "Soutien scolaire le matin, activités ludiques l'après-midi, sorties à la journée. Goûters et déjeuners inclus.",
    color: "ocean",
  },
  {
    id: "activites",
    icon: Gamepad2,
    title: "Activités & Détente",
    short: "Sociabiliser et diminuer l'exposition aux écrans",
    desc: "Guitare, ukulélé, coin lecture, jeux de société, basket, balançoire... pour apprendre autrement.",
    color: "lagoon",
  },
];

// Activités pour la page services
export const ACTIVITES = [
  { icon: Music, label: "Activités culturelles (guitare, ukulélé)" },
  { icon: BookOpen, label: "Coin lecture et de relaxation" },
  { icon: Gamepad2, label: "Jeux de société (échecs, etc.)" },
  { icon: Trees, label: "Jeux en extérieur (basket, balançoire)" },
];

// Pourquoi nous choisir
export const VALEURS = [
  {
    icon: ShieldCheck,
    title: "Environnement sécurisé",
    desc: "Surveillance permanente, locaux adaptés, encadrement professionnel.",
  },
  {
    icon: Heart,
    title: "Approche bienveillante",
    desc: "Chaque enfant progresse à son rythme dans une ambiance chaleureuse.",
  },
  {
    icon: Sparkles,
    title: "Méthodes adaptées",
    desc: "Soutien personnalisé de la maternelle au collège pour tous les niveaux.",
  },
  {
    icon: Users,
    title: "Communauté locale",
    desc: "8 écoles partenaires sur Papara et Mataiea — proximité et confiance.",
  },
];

// Tarifs soutien forfait mensuel (base 3 semaines/mois)
export const TARIFS_SOUTIEN = [
  { freq: "2x / semaine / mois", prix: 20000, per_half: 3333, key: "2x" },
  { freq: "3x / semaine / mois", prix: 27000, per_half: 3000, key: "3x" },
  { freq: "4x / semaine / mois", prix: 33000, per_half: 2750, key: "4x" },
  { freq: "5x / semaine / mois", prix: 38000, per_half: 2533, key: "5x" },
];

export const TARIFS_TRANSPORT = [
  { freq: "2x / semaine / mois", prix: 1600, per_trip: 200, key: "2x" },
  { freq: "3x / semaine / mois", prix: 2400, per_trip: 133, key: "3x" },
  { freq: "4x / semaine / mois", prix: 3200, per_trip: 100, key: "4x" },
  { freq: "5x / semaine / mois", prix: 3900, per_trip: 78, key: "5x" },
];

export const TARIFS_MATIN = [
  { freq: "2x / semaine / mois", prix: 8000, per_day: 1333, key: "2x" },
  { freq: "3x / semaine / mois", prix: 10000, per_day: 1111, key: "3x" },
  { freq: "4x / semaine / mois", prix: 11500, per_day: 958, key: "4x" },
  { freq: "5x / semaine / mois", prix: 13000, per_day: 866, key: "5x" },
];

export const TARIF_MATIN_UNITAIRE = 1500;

export const TARIF_DEMI_JOURNEE = 3500;
export const TARIF_TRAJET = 400;
export const TARIF_STAGE = {
  non_abonne_jour: 7000,
  non_abonne_semaine: 22000,
  abonne_jour: 6000,
  abonne_semaine: 17000,
};

// Horaires
export const HORAIRES_SOUTIEN = [
  { label: "Accueil", value: "à partir de 11h30" },
  { label: "Fermeture", value: "17h" },
];

export const HORAIRES_STAGE = [
  { label: "Accueil", value: "à partir de 7h" },
  { label: "Soutien", value: "de 8h30 à 11h30" },
  { label: "Fin activités", value: "15h" },
  { label: "Fermeture", value: "17h" },
];

// Écoles partenaires
export const ECOLES = {
  papara: ["École Taharuu", "École Apatea", "École Apea", "École Tiamao", "Collège de Papara"],
  mataiea: ["École Mairipehe", "École Nuutafaratea", "Collège de Mataiea"],
};

export const HORAIRES_MATIN = [
  { label: "Accueil", value: "à partir de 4h" },
  { label: "Petit-déjeuner", value: "au centre" },
  { label: "Départ écoles", value: "selon horaires" },
];

// Formules pour le formulaire d'inscription
export const FORMULES = [
  {
    id: "soutien",
    label: "Soutien scolaire (mensuel)",
    description: "Accompagnement quotidien après l'école — goûter inclus",
    options: TARIFS_SOUTIEN,
  },
  {
    id: "matin",
    label: "Accueil du matin",
    description: "Dès 4h — petit-déjeuner et dépose à l'école",
    options: TARIFS_MATIN,
  },
  {
    id: "stage_vacances",
    label: "Stage de vacances",
    description: "Pendant les vacances scolaires (déjeuner inclus)",
    options: [
      { freq: "1 journée (non abonné)", prix: 7000, key: "jour_non_abonne" },
      { freq: "Semaine (non abonné)", prix: 22000, key: "semaine_non_abonne" },
      { freq: "1 journée (abonné soutien)", prix: 6000, key: "jour_abonne" },
      { freq: "Semaine (abonné soutien)", prix: 17000, key: "semaine_abonne" },
    ],
  },
];

export const NIVEAUX = ["SM", "SG", "CP", "CE1", "CE2", "CM1", "CM2", "6ème", "5ème", "4ème", "3ème"];

// Équipe
export const EQUIPE = [
  {
    prenom: "Vaianu",
    role: "Directeur & Tuteur des collégiens",
    diplomes: ["BAC+3", "BAFA", "MBA (en cours)"],
    photo: "/team/vaianu.jpg",
    accent: "ocean",
  },
  {
    prenom: "Juanita",
    role: "Tutrice des petits (SM à CP)",
    diplomes: ["BAFA", "BAFD (en cours)"],
    photo: "/team/juanita.jpg",
    accent: "coral",
  },
  {
    prenom: "Joséphine",
    role: "Tutrice des moyens (CE1 à CE2)",
    diplomes: ["Baccalauréat", "BAFA"],
    photo: "/team/josephine.jpg",
    accent: "lagoon",
  },
  {
    prenom: "Maro",
    role: "Tuteur des grands (CM1 à CM2)",
    diplomes: ["Baccalauréat", "BAFA", "BAFD"],
    photo: "/team/maro.jpg",
    accent: "coral",
  },
  {
    prenom: "Allan",
    role: "Tuteur des collégiens",
    diplomes: ["Baccalauréat (mention très bien)"],
    photo: "/team/allan.jpg",
    accent: "ocean",
  },
];

// Témoignages parents (source : Facebook)
export const TEMOIGNAGES = [
  {
    prenom: "Linda",
    texte: "❤️❤️❤️ Merci d'exister 🙏🙏🙏 Ma fille adore y être et a déjà hâte d'y retourner 🥰🥰🥰",
    couleur: "coral",
  },
  {
    prenom: "Teiva",
    texte: "Depuis que mon fils va au centre, ses notes ont bien remonté et surtout il ne râle plus pour faire ses devoirs. Un vrai soulagement pour toute la famille.",
    couleur: "ocean",
  },
  {
    prenom: "Heiata",
    texte: "Une équipe très à l'écoute et bienveillante. Le ramassage à l'école est un vrai plus, je peux enchaîner mon travail sans stress. Je recommande à 100 %.",
    couleur: "lagoon",
  },
];

export const formatXPF = (n) =>
  new Intl.NumberFormat("fr-FR").format(n).replace(/\s/g, " ") + " XPF";
